module.exports = __webpack_public_path__ + "static/media/phone.3ea8465e.jpeg";